import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RegistrationFieldConfigModel } from "../models/registration-field-configs/registration-field-config.model";
import { Configuration } from "src/assets/Configuration";
import { Observable } from "rxjs";
import { RegistrationFieldConfigUpdateModel } from "../models/registration-field-configs/registration-field-config-update.model";

@Injectable({
  providedIn: 'root'
})
export class RegistrationFieldConfigService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  public getAllRegistrationFieldConfigs(): Observable<RegistrationFieldConfigModel[]> {
    return this.httpClient.get<RegistrationFieldConfigModel[]>(
      Configuration.getApiBaseUrl() + "/registration-field-config"
    );
  }

  public updateRegistrationFieldConfigs(
    configs: RegistrationFieldConfigUpdateModel[]
  ): Observable<RegistrationFieldConfigModel[]> {
    return this.httpClient.put<RegistrationFieldConfigModel[]>(
      Configuration.getApiBaseUrl() + "/registration-field-config",
      configs
    );
  }
}
